module.exports = __webpack_public_path__ + "static/media/board-approved-logo@3x.364d0899.png";